export default __webpack_public_path__ + "static/media/Kyouth-logo.e0f9b503.svg";